<template>
  <div class="passenger-title is-size-5-touch">
    {{$t('passengerTitle.header', { passenger: passenger })}}
  </div>
</template>

<script>
export default {
  name: 'PassengerTitle',
  components: {
  },
  props: {
    passenger: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  methods: {
  },
  computed: {
  },
  filters: {
  },
  created() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Passenger/PassengerTitle.vue